export default __webpack_public_path__ + "static/media/donut-uniswap.ed28458f.png";